import cn from 'classnames';
import type { FC } from 'react';
import { enableScroll } from '@shared/helpers';
import { useAppDispatch, useAppSelector } from '@shared/hooks';
import { ButtonTransparent, ModalSmall } from 'library/components/common';
import { closeDialogModal, selectDialogProps } from 'library/redux/modal';
import * as st from './ModalDialog.module.scss';

const ModalDialog: FC = () => {
  const dispatch = useAppDispatch();
  const data = useAppSelector(selectDialogProps);
  const closeModal = () => {
    dispatch(closeDialogModal());
  };

  const handleConfirm = () => {
    enableScroll();
    if (!Boolean(data.closeToConfirm) && data.closeToConfirm !== undefined) {
      data.confirm && data.confirm();
    } else {
      closeModal();
      data.confirm && data.confirm();
    }
  };

  const handleReject = () => {
    enableScroll();
    data.decline && data.decline();
    dispatch(closeDialogModal());
  };

  const isButtonsRevert = data.isButtonsRevert;

  return (
    <ModalSmall
      isOpen={true}
      needClose={data.isNeedClose}
      title={data.title}
      className={data?.modalClassName}
      overlayClassName={cn(st.overlay, data?.overlayClassName)}
      onRequestClose={closeModal}
    >
      <div
        className={cn(
          st.wrapper,
          !Boolean(data.closeToConfirm) && data.closeToConfirm !== undefined && st.height,
          data?.wrapperClassName
        )}
      >
        <div className={cn(st.wrapper__text, data?.textClassName)}>{data.text}</div>
        {data.link && (
          <a
            href={data.link.url}
            rel="noopener noreferrer"
            target="_blank"
            className={st.wrapper__text_link}
          >
            {data.link.text}
          </a>
        )}
      </div>
      <div className={cn(st.buttons, data?.buttonsClassName)}>
        <div className={cn(st.buttons__button, data?.buttonClassName)}>
          <ButtonTransparent
            handler={isButtonsRevert ? handleReject : handleConfirm}
            text={isButtonsRevert ? data.declineText : data.confirmText}
            theme={isButtonsRevert ? 'grey' : 'blue'}
          />
        </div>
        <div className={cn(st.buttons__button, data?.buttonClassName)}>
          <ButtonTransparent
            handler={isButtonsRevert ? handleConfirm : handleReject}
            text={isButtonsRevert ? data.confirmText : data.declineText}
            theme={isButtonsRevert ? 'blue' : 'grey'}
          />
        </div>
      </div>
    </ModalSmall>
  );
};

export default ModalDialog;
